import {AutenticacionPopupController} from "./autenticacion";
import {SubmenuController} from "./submenu";

export class UserHeaderController {

    /* INSTANCE */
    public static instance: UserHeaderController;
    private active?: any;
    private overlay?: HTMLElement;

    /* STATIC */
    public static async build(): Promise<UserHeaderController> {
        return UserHeaderController.instance = new this();
    }

    private constructor() {
        this.init();
    }

    private async init(): Promise<void> {
        document.querySelector(".boton-acceso")?.addEventListener("click", async () => {
            const elEnabled = document.querySelector(".enabled") as HTMLElement;
            const estilosNotInline = window.getComputedStyle(elEnabled);
            if (estilosNotInline.display === "none" || elEnabled.style.display === "none") {
                if (elEnabled.classList.contains("login-ed-auth")) {
                    this.createOverlay(AutenticacionPopupController.instance.getComponent().window);
                }
                if (elEnabled.classList.contains("login-ed-mn")) {
                    if (window.device === "mv") {
                        this.createOverlay(SubmenuController.instance.submenu?.window as HTMLElement);
                    }
                }
                elEnabled.style.display = "block";
            } else {
                elEnabled.style.display = "none";
            }
        });
    }

    public createOverlay(active: HTMLElement): void {
        if (!this.overlay) {
            const overlay = document.createElement("div");
            overlay.classList.add("overlay-capa");
            this.overlay = overlay;
            document.getElementsByTagName("body").item(0)?.appendChild(overlay);
        } else {
            this.overlay.removeEventListener("click", this.active);
        }
        document.getElementsByTagName("body").item(0)?.classList.add("block-page");
        this.active = this.addEventOverlay.bind(this, this.overlay, active);
        this.overlay.addEventListener("click", this.active);
    }

    public destroyOverlay(): void {
        this.active = undefined;
        this.overlay?.remove();
        this.overlay = undefined;
        document.getElementsByTagName("body").item(0)?.classList.remove("block-page");
    }

    private addEventOverlay(overlay: HTMLElement, active: HTMLElement): void {
        overlay?.remove();
        active.style.display = "none";
        this.overlay = undefined;
        document.getElementsByTagName("body").item(0)?.classList.remove("block-page");
    }

}
